import { createContext, useState, Fragment } from "react";
import { useNavigate } from "react-router-dom";

export const menuContext = createContext();

const ContextProvider = ({ children }) => {

  const navigate = useNavigate();
  const [menuStatus, setMenuStatus] = useState(false);

  const goToHome = () => {
    navigate("/");
  }

  const goToAbout = () => {
    navigate("/about");
  }

  const goToSolution = () => {
    navigate("/solution");
  }

  const goToProductDetail = () => {
    navigate("/product");
  }

  const goToBlogs = () => {
    navigate("/blog");
  }

  const goToBlogDetails = (slug) => {
    navigate(`/blog/${slug}`);
  }

  const goToContactUs = () => {
    navigate("/contactus");
  }

  const goToEvents = () => {
    navigate("/events");
  }


  const dataToPass = {
    menuStatus,
    setMenuStatus,
    goToHome,
    goToAbout,
    goToSolution,
    goToProductDetail,
    goToBlogs,
    goToBlogDetails,
    goToContactUs,
    goToEvents
  }


  return (
    <Fragment>
      <menuContext.Provider value={{...dataToPass}}>
        {children}
      </menuContext.Provider>
    </Fragment>
  );
};

export default ContextProvider;